import { Button } from '@daily/shared/components/Button';
import { CardContent } from '@daily/shared/components/Card';
import { CloseIcon } from '@daily/shared/components/Icons/CloseIcon';
import { Popover } from '@daily/shared/components/Popover';
import { VisuallyHidden } from '@daily/shared/components/VisuallyHidden';
import { useTranslation } from 'react-i18next';

import { useLocalAudioStatus } from '/hooks/useLocalAudioStatus';

interface Props {
  labelledBy: string;
}

export const SpeakingMutedPopover: React.FC<Props> = ({ labelledBy }) => {
  const { t } = useTranslation();
  const { dismiss, isSpeakingButMuted } = useLocalAudioStatus();

  if (!isSpeakingButMuted) return;

  return (
    <Popover
      aria-labelledby={labelledBy}
      id="speaking-muted-popover"
      placement="top"
      align="left"
      cardProps={{
        spacing: 8,
      }}
      position="fixed"
      permanent
      focusTrapProps={{
        active: false,
      }}
    >
      <CardContent>
        <div className="speaking-muted-popover-content">
          <p aria-live="assertive">
            {t('audio.speakingWhileMutedNotification')}
          </p>
          <Button variant="ghost" onClick={dismiss}>
            <CloseIcon size={16} variant="default" />
            <VisuallyHidden>{t('general.dismiss')}</VisuallyHidden>
          </Button>
        </div>
      </CardContent>
      <style jsx>{`
        .speaking-muted-popover-content {
          align-items: flex-start;
          display: flex;
          gap: 8px;
          max-width: 200px;
          position: relative;
        }
        p {
          margin: 0;
        }
      `}</style>
    </Popover>
  );
};
